export default {
  name: 'AppText',
  props: {
    text: {
      type: String,
    },
  },
  methods: {
    prepare() {
      let text = this.text
      text = text.replace(/[0-9] /ig, '&nbsp;')
      text = text.replace(/— /ig, '—&nbsp;')
      return text
    }
  },
  render: function (createElement) {
    return createElement('div',
      {
        attrs: {
          class: this.className
        },
        on: this.$listeners,
        domProps: {
          innerHTML: this.prepare()
        },
      })
  }
}